"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const danger = {
    100: '#FFF6F5',
    200: '#FCD1D1',
    300: '#F7A4A5',
    400: '#F17A7B',
    500: '#E85153',
    600: '#DE2A2C',
    700: '#B41F21',
    800: '#891517',
    900: '#5D0D0E'
};
exports.default = danger;
